export default __webpack_public_path__ + "static/media/edit.dae95401.svg";